import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-opportunities',
  templateUrl: './social-opportunities.component.html',
  styleUrls: ['./social-opportunities.component.scss']
})
export class SocialOpportunitiesComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
